// Copyright (c) StrangeBee 2024

import React, { ReactNode, ReactElement } from 'react';
import { useDrag } from 'react-dnd';

import './DraggableElement.scss';

interface DraggableElementProps {
    children: ReactNode;
    onDragFinish: (dropResult: any) => void;
    dragType: string;
}

const DraggableElement = ({ children, onDragFinish, dragType }: DraggableElementProps): ReactElement => {
    const [{ isDragging }, drag] = useDrag({
        item: { type: dragType },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();

            if (dropResult) {
                onDragFinish?.(dropResult);
            }
        },
    });

    return (
        <div ref={drag} className={`draggable-element ${isDragging ? 'dragged' : ''}`}>
            {children}
        </div>
    );
};

export default DraggableElement;
